import { gql } from "@apollo/client";

export const INIT_PARAM_VALUE_QUERY = gql`
  query initializationParamValue($paramName: String!) {
    initializationParamValue(paramName: $paramName) {
      value
    }
  }
`;

export const LEGAL_FORM_VALUES_QUERY = gql`
  query legalFormValues($type: String!) {
    legalFormValues(type: $type) {
      id
      code
      name
    }
  }
`;

export const GENDER_VALUES_QUERY = gql`
  query genderValues($type: String!) {
    genderValues(type: $type) {
      id
      code
      name
    }
  }
`;

export const CITIES_QUERY = gql`
  query cities($cityTypeId: Int!, $parentCityId: Int) {
    cities(cityTypeId: $cityTypeId, parentCityId: $parentCityId) {
      id
      code
      name
      type
    }
  }
`;

export const CURRENCIES_QUERY = gql`
  query currencies {
    currencies {
      id
      code
    }
  }
`;

export const USER_DATA = gql`
  query clientUserData {
    userData @client {
      id
      isInternalUser
      countryId
      showAmountsWithVAT
      isExchangeRateFunctionality
      allowIndividualSearch
      allowAutomatedDecision
      showQuestionsInVCP
      showDecisionReasons
      dealerDrivenConsent
      customerDrivenConsent
      requestAlwaysConsent
      allowSoleTraderSearch
      allowInsurance
      allowSelectionInsuranceConvention
      useDownloadProductInStep4
      user
      admin
      dAdmin
      vAdmin
      estimator
    }
  }
`;

export const PRODUCT_SERVICE_TYPES = gql`
  query productServiceTypes($productId: Int!) {
    productServiceTypes(productId: $productId) {
      serviceTypeId
      serviceCode
      serviceName
      calcTypeId
      readOnly
      defaultPercent
      minPercent
      maxPercent
      defaultValue
      financedYN
      periodicity
      minValue
      maxValue
    }
  }
`;

export const SUPPLIERS_QUERY = gql`
  query suppliers {
    suppliers {
      id
      name
    }
  }
`;

export const GET_CELL_PARAMS_TEMPLATE_QUERY = gql`
  query cellParamsTemplate(
    $cellParamsTemplateId: Int!
    $productId: Int!
    $scheduleTypeId: Int!
    $duration: Int!
    $firstInstallmentDate: DateTime!
    $periodicity: Int!
  ) {
    cellParamsTemplate(
      cellParamsTemplateId: $cellParamsTemplateId
      productId: $productId
      scheduleTypeId: $scheduleTypeId
      duration: $duration
      firstInstallmentDate: $firstInstallmentDate
      periodicity: $periodicity
    ) {
      scheduleTypeCellParamTemplateId
      templateName
      cellParamsConfigurations {
        monthDate
        params {
          scheduleTypeCellParamId
          scheduleTypeCellParamCode
          value
        }
      }
    }
  }
`;

export const GET_DICTIONARY = gql`
  query dictionary($dictionaryName: String!) {
    dictionary(dictionaryName: $dictionaryName) {
      id
      code
      name
    }
  }
`;

export const TENANT_QUERY = gql`
  query tenant($tenantId: String!) {
    tenant(tenantId: $tenantId) {
      id
      isValid
      userPrivacyAgreementNeeded
    }
  }
`;

export const AREA_OF_ACTIVITIES_QUERY = gql`
  query areaOfActivities {
    areaOfActivities {
      id
      code
      name
    }
  }
`;

export const CURRENT_DEALER_ID_QUERY = gql`
  query currentDealer {
    currentDealer @client {
      id
      name
    }
  }
`;

export const DEALERS_USER = gql`
  query getUserDealers {
    getUserDealers {
      selectedDealerId
      selectedDealerName
      dealers {
        id
        name
      }
    }
  }
`;

export const SET_CURRENT_DEALER = gql`
  mutation setCurrentDealer($dealerId: Int!) {
    setCurrentDealer(dealerId: $dealerId)
  }
`;
